<template>
  <div class="pc-header">
    <TNB :clearNav="clearNav" />
    <div class="header">
      <div class="header-container">
        <router-link to="/" @click="clearNav">
          <div class="header-logo"></div>
        </router-link>

        <div class="header-item-container">
          <div
            v-for="menu in menus"
            :key="menu.id"
            class="header-item"
            @click="updateNav(menu)"
          >
            <router-link :to="menu.link">{{ menu.title }}</router-link>
            <ul class="dropdown-menu" v-if="menu.dropdown">
              <li v-for="item in menu.dropdown" :key="item.name">
                <router-link :to="item.link">{{ item.name }}</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <Nav :navItems="navItems" :isVisible="isNavVisible" />
  </div>

  <div class="m-header">
    <div class="m-header-container">
      <router-link to="/" @click="closeSideMenu">
        <div class="m-header-logo"></div>
      </router-link>

      <svg
        width="40"
        height="40"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="toggleSideMenu"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 12C2 11.4477 2.44772 11 3 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H3C2.44772 13 2 12.5523 2 12Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 6C2 5.44772 2.44772 5 3 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H3C2.44772 7 2 6.55228 2 6Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 18C2 17.4477 2.44772 17 3 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H3C2.44772 19 2 18.5523 2 18Z"
          fill="white"
        />
      </svg>
    </div>

    <!-- Side Menu -->
    <SideMenu v-if="isSideMenuVisible" :menus="menus" @close="toggleSideMenu" />
  </div>
</template>

<script>
import Nav from "../components/NavView.vue";
import TNB from "../components/TNBView.vue";
import SideMenu from "../components/SideMenu.vue";

export default {
  components: {
    Nav,
    TNB,
    SideMenu,
  },
  data() {
    return {
      isNavVisible: false,
      isSideMenuVisible: false,
      navItems: [],
      menus: [
        {
          id: 1,
          title: "ABOUT US",
          link: { name: "greetings" },
          dropdown: [
            {
              name: "이치윤피디 인사말",
              link: { name: "greetings" },
            },
            { name: "우리는", link: { name: "about" } },
          ],
        },
        {
          id: 2,
          title: "프로그램",
          link: { name: "vfx" },
          dropdown: [
            { name: "VFX", link: { name: "vfx" } },
            { name: "특수촬영", link: { name: "specialFilming" } },
            { name: "특수음향", link: { name: "specialSound" } },
            { name: "특수조명", link: { name: "specialLighting" } },
            { name: "특수효과", link: { name: "specialEffects" } },
            { name: "무술액션", link: { name: "martialArtsAction" } },
          ],
        },
        {
          id: 3,
          title: "BRAND_이치윤",
          link: { name: "brandlcy" },
          dropdown: [{ name: "브랜드스토리", link: { name: "brandlcy" } }],
        },
        {
          id: 4,
          title: "우리 팀 HISTORY",
          link: { name: "vfx" },
          dropdown: [
            { name: "VFX", link: { name: "vfx" } },
            { name: "특수촬영", link: { name: "specialFilming" } },
            { name: "특수음향", link: { name: "specialSound" } },
            { name: "특수조명", link: { name: "specialLighting" } },
            { name: "특수효과", link: { name: "specialEffects" } },
            { name: "무술액션", link: { name: "martialArtsAction" } },
          ],
        },
        {
          id: 5,
          title: "NEWS CENTER",
          link: { name: "news" },
        },
        {
          id: 6,
          title: "STUDY CENTER",
          link: { name: "vfx" },
          dropdown: [
            { name: "VFX ROOM", link: { name: "vfx" } },
            { name: "특수촬영 ROOM", link: { name: "specialFilming" } },
            { name: "특수음향 ROOM", link: { name: "specialSound" } },
            { name: "특수조명 ROOM", link: { name: "specialLighting" } },
            { name: "특수효과 ROOM", link: { name: "specialEffects" } },
            { name: "무술액션 ROOM", link: { name: "martialArtsAction" } },
          ],
        },
        {
          id: 7,
          title: "커뮤니티",
          link: { name: "notice" },
          dropdown: [
            { name: "공지사항", link: { name: "notice" } },
            { name: "보도자료", link: { name: "pressRelease" } },
            { name: "뉴스레터", link: { name: "news" } },
            { name: "티켓FAQ", link: { name: "ticket" } },
          ],
        },
      ],
    };
  },
  mounted() {
    // 새 창에서 접근한 경우 확인
    const isNewWindow = !sessionStorage.getItem("mainPageVisited");

    if (isNewWindow) {
      this.clearNav(); // 새 창에서 접근 시 nav 초기화
    } else {
      const savedNav = localStorage.getItem("selectedNav");
      if (savedNav) {
        this.navItems = JSON.parse(savedNav);
        this.isNavVisible = true;
      }
    }
    // 페이지 방문 여부 기록 (새 창에서 접근 여부를 판별하기 위함)
    sessionStorage.setItem("mainPageVisited", "true");
  },
  methods: {
    updateNav(menu) {
      if (menu.dropdown) {
        this.navItems = menu.dropdown;
        this.isNavVisible = true;
        localStorage.setItem("selectedNav", JSON.stringify(menu.dropdown)); // 상태 저장
      } else {
        this.clearNav();
      }
    },
    clearNav() {
      this.isNavVisible = false;
      this.navItems = [];
      localStorage.removeItem("selectedNav"); // 상태 삭제
    },
    closeSideMenu() {
      this.clearNav();
      this.isSideMenuVisible = false;
    },
    toggleSideMenu() {
      // Toggle side menu visibility
      this.isSideMenuVisible = !this.isSideMenuVisible;
    },
  },
};
</script>

<style>
@import "../assets/css/header.css";
</style>
